import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

const selectors = {
  cardFeedContent: '[data-card-feed-content]',
  prevButton: '.splide__arrow--prev',
  nextButton: '.splide__arrow--next',
};

export default class DynamicCardFeed {
  constructor(section) {
    this.el = section.el;
    this.section = section;
    this.cardFeedContent = this.el.querySelector(selectors.cardFeedContent);

    this.prevButton = this.el?.querySelector(selectors.prevButton);

    if (this.prevButton) {
      this.prevButton.disabled = true;
    }

    this.nextButton = this.el?.querySelector(selectors.nextButton);

    const xsWidth = section.data.xsWidth || 220;
    const smWidth = section.data.smWidth || 240;
    const mdWidth = section.data.mdWidth || 260;
    const lgWidth = section.data.lgWidth || 290;
    const hasSideContent = section.data.hasSideContent || false;

    this.updateButtons.bind(this);

    this.carousel = initCarousel(
      this.el,
      {
        arrows: !hasSideContent,
        pagination: false,
        fixedWidth: xsWidth,
        gap: '1rem',
        mediaQuery: 'min',
        type: 'slide',
        drag: true,
        snap: true,
        perMove: 1,
        breakpoints: {
          [unitlessBreakpoints.sm]: {
            fixedWidth: smWidth,
          },
          [unitlessBreakpoints.md]: {
            fixedWidth: mdWidth,
          },
          [unitlessBreakpoints.lg]: {
            fixedWidth: lgWidth,
          },
        },
      },
      true,
    );

    this.prevButton.addEventListener('click', () => {
      this.carousel.go('<');
    });

    this.nextButton.addEventListener('click', () => {
      this.carousel.go('>');
    });

    this.carousel.on('move', () => {
      this.updateButtons();
    });
  }

  updateButtons() {
    if (
      this.carousel.index + this.carousel.options.perPage >=
      this.carousel.length
    ) {
      this.nextButton.disabled = true;
    } else {
      this.nextButton.disabled = false;
    }

    if (this.carousel.index > 0) {
      this.prevButton.disabled = false;
    } else {
      this.prevButton.disabled = true;
    }
  }
}
